import React from 'react'
import RemoteActionStatusBadge from './RemoteActionStatusBadge'

class OpeningsList extends React.Component {

  formatTime(timestamp) {
    const d = new Date(timestamp)
    d.setHours(d.getHours() - 2)
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
  }

  getOpensLabel(opens) {
    if (opens === 0) return { label: '0 restantes', cls: 'olist-opens olist-opens--none' }
    if (opens === 1) return { label: '1 restante',  cls: 'olist-opens olist-opens--warn' }
    return { label: `${opens} restantes`, cls: 'olist-opens olist-opens--ok' }
  }

  render() {
    const { openings } = this.props

    if (!openings || openings.length === 0) {
      return (
        <div className="olist-empty">
          <i className="fas fa-door-open"></i>
          <p>No hay aperturas para el período seleccionado</p>
        </div>
      )
    }

    return (
      <div className="olist-grid">
        {openings.map(opening => {
          const { label: opensLabel, cls: opensCls } = this.getOpensLabel(opening.Opens)
          return (
            <div key={opening._id} className="olist-card">
              <div className="olist-card-top">
                <RemoteActionStatusBadge status={opening.Status} />
                <span className={opensCls}>{opensLabel}</span>
                <span className="olist-time">{this.formatTime(opening.TimeStamp)}</span>
              </div>
              <div className="olist-card-body">
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-desktop"></i> Máquina</span>
                  <span className="olist-value">{opening.Machine}</span>
                </div>
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-user"></i> Cliente</span>
                  <span className="olist-value">{opening.Customer && opening.Customer.Fullname}</span>
                </div>
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-box"></i> Taquilla</span>
                  <span className="olist-value olist-matricula">{opening.Matricula}</span>
                </div>
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-barcode"></i> SN</span>
                  <span className="olist-value">{opening.Locker}</span>
                </div>
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-phone"></i> Teléfono</span>
                  <span className="olist-value">{opening.Phone}</span>
                </div>
                <div className="olist-field">
                  <span className="olist-label"><i className="fas fa-key"></i> Código</span>
                  <span className="olist-value olist-code">{opening.AccessCode}</span>
                </div>
              </div>
              <div className="olist-card-footer">
                <span className="olist-invoice"><i className="fas fa-file-invoice"></i> {opening.Invoice || '—'}</span>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default OpeningsList

